import axios from "axios";
import config from "../config";

// Character types
export type Character = {
  id: string;
  name: string;
  unique_name: string;
};

export type Characters = {
  characters: Character[];
};

export type CharacterInChatRoom = {
  id: string;
  name: string;
  unique_name: string;
  profile: string | null;
  scene: string | null;
  llm_model_id: string;
};

export type CharactersInChatRoom = {
  characters: CharacterInChatRoom[];
};

export type RegisterCharacterInput = {
  name: string;
  unique_name: string;
};

export type RegisterCharacterOutput = {
  id: string;
};

export type UpdateCharacterInput = {
  name: string;
};

export type JoinCharacterChatRoomInput = {
  profile: string | null;
  scene: string | null;
  llm_model_id: string;
};

export type UpdateCharacterInChatRoomInput = {
  profile: string | null;
  scene: string | null;
  llm_model_id: string;
};

export type GenerateMessageOutput = {
  messages: string[];
};

export const registerCharacter = async (
  token: string,
  data: RegisterCharacterInput,
): Promise<RegisterCharacterOutput> => {
  const response = await axios.post<RegisterCharacterOutput>(`${config.apiUrl}/characters`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const updateCharacter = async (
  token: string,
  characterId: string,
  data: UpdateCharacterInput,
): Promise<void> => {
  await axios.put(`${config.apiUrl}/characters/${characterId}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getCharactersByChatRoomId = async (token: string, chatRoomId: string): Promise<CharactersInChatRoom> => {
  const response = await axios.get<CharactersInChatRoom>(`${config.apiUrl}/chat-rooms/${chatRoomId}/characters`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const joinCharacterChatRoom = async (
  token: string,
  chatRoomId: string,
  characterId: string,
  data: JoinCharacterChatRoomInput,
): Promise<void> => {
  await axios.post(`${config.apiUrl}/chat-rooms/${chatRoomId}/characters/${characterId}/join`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const updateCharacterInChatRoom = async (
  token: string,
  chatRoomId: string,
  characterId: string,
  data: UpdateCharacterInChatRoomInput,
): Promise<void> => {
  await axios.put(`${config.apiUrl}/chat-rooms/${chatRoomId}/characters/${characterId}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const generateCharacterMessages = async (
  token: string,
  characterId: string,
  chatRoomId: string,
  generationCount: number,
): Promise<GenerateMessageOutput> => {
  const response = await axios.get<GenerateMessageOutput>(
    `${config.apiUrl}/characters/${characterId}/chat-rooms/${chatRoomId}/messages/generate/${generationCount}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return response.data;
};

export const listCharactersByAccountId = async (token: string, accountId: string): Promise<Characters> => {
  const response = await axios.get<Characters>(`${config.apiUrl}/accounts/${accountId}/characters`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const getCharacterInChatRoom = async (
  token: string,
  chatRoomId: string,
  characterId: string,
): Promise<CharacterInChatRoom> => {
  const response = await axios.get<CharacterInChatRoom>(
    `${config.apiUrl}/chat-rooms/${chatRoomId}/characters/${characterId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return response.data;
};

export const listCharacters = async (token: string): Promise<Characters> => {
  const response = await axios.get<Characters>(`${config.apiUrl}/characters`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};
